import React from "react";

function Icon() {
  return (
    <svg
      className="footerLogoImg"
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="90"
      version="1.1"
      viewBox="0 0 150 90"
    >
      <path
        fill="#fff"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#fffffa"
        strokeOpacity="1"
        strokeWidth="1.004"
        d="M10.727 6.726L7.82 10.103v48.543l.011.014 2.762 3.238h11.518l2.664-3.072-.07-13.53 13.507 16.602H50.03l2.507-2.95V10.024l-.021.027-2.602-3.324H38.641l-2.986 3.46-.098 13.85-13.484-17.31z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#fff"
        strokeOpacity="1"
        strokeWidth="0.951"
        d="M54.967 5.888l-2.476 3.338v37.297l.05-15.908 13.811 16.808v10.465l2.701 3.246h11.86l2.398-2.896.1-10.64 13.736-16.983.1 20.23 8.293 10.24v.05h28.523l8.24-10.073V40.406h-.1l-2.745-3.348h-14.336v3.348h-10.84l.1-13.338 10.84.05-.1 3.196 14.535.101 2.646-3.27V16.172L133.82 5.888h-28.043l-8.379 10.19.1-6.493-2.832-3.697H83.518l-3.254 3.348v7.392l-5.144 6.594-5.746-6.943V9.335l-2.81-3.447z"
      ></path>
      <path
        d="M8.562 63.645h4.74q1.408 0 2.096.12.695.114 1.237.486.55.372.915.995.364.615.364 1.384 0 .833-.453 1.529-.445.695-1.214 1.043 1.084.316 1.667 1.076.582.76.582 1.788 0 .81-.38 1.578-.372.76-1.027 1.221-.648.453-1.602.558-.599.065-2.888.081H8.562zm2.394 1.973v2.743h1.57q1.4 0 1.74-.04.614-.073.962-.421.356-.356.356-.93 0-.55-.308-.89-.299-.348-.898-.421-.356-.04-2.046-.04zm0 4.717v3.171h2.217q1.294 0 1.642-.073.534-.097.866-.469.34-.38.34-1.011 0-.534-.26-.906-.258-.372-.752-.542-.485-.17-2.12-.17zm15.201 5.17v-1.287q-.469.688-1.237 1.084-.76.397-1.61.397-.866 0-1.554-.38-.687-.38-.995-1.069-.307-.687-.307-1.9v-5.437h2.273v3.948q0 1.812.122 2.224.129.405.46.648.332.234.842.234.582 0 1.044-.315.46-.324.63-.793.17-.477.17-2.322v-3.624h2.274v8.591zm4.466-9.757v-2.103h2.273v2.103zm0 9.756v-8.591h2.273v8.591zm4.603 0v-11.86H37.5v11.86zm12.483 0h-2.112v-1.262q-.526.737-1.246 1.1-.711.357-1.44.357-1.48 0-2.54-1.19-1.051-1.197-1.051-3.333 0-2.184 1.027-3.317 1.027-1.14 2.597-1.14 1.44 0 2.491 1.197v-4.271h2.274zm-6.068-4.481q0 1.375.38 1.99.55.89 1.538.89.784 0 1.334-.664.55-.671.55-1.998 0-1.48-.533-2.128-.534-.655-1.368-.655-.809 0-1.359.647-.542.64-.542 1.918zm8.309-5.275v-2.103h2.273v2.103zm0 9.756v-8.591h2.273v8.591zm12.418 0h-2.274V71.12q0-1.392-.145-1.796-.146-.413-.478-.64-.323-.226-.784-.226-.59 0-1.06.324-.47.323-.647.857-.17.534-.17 1.974v3.891h-2.273v-8.591h2.111v1.262q1.125-1.456 2.832-1.456.752 0 1.375.275.623.267.938.687.324.421.445.955.13.534.13 1.529zm2.095.567l2.597.315q.064.453.3.623.323.243 1.018.243.89 0 1.335-.267.3-.178.453-.575.105-.283.105-1.043v-1.254q-1.019 1.391-2.572 1.391-1.731 0-2.743-1.464-.792-1.157-.792-2.88 0-2.16 1.035-3.3 1.044-1.141 2.589-1.141 1.594 0 2.63 1.4v-1.206h2.127v7.71q0 1.52-.251 2.273-.25.752-.704 1.18-.453.43-1.213.672-.753.243-1.91.243-2.184 0-3.098-.752-.914-.745-.914-1.893 0-.114.008-.275zm2.03-5.04q0 1.367.526 2.006.534.63 1.31.63.834 0 1.409-.646.574-.656.574-1.934 0-1.335-.55-1.982t-1.392-.647q-.817 0-1.35.64-.527.63-.527 1.933zm7.5 2.022l2.281-.348q.146.664.59 1.011.446.34 1.247.34.881 0 1.326-.323.3-.227.3-.607 0-.259-.162-.429-.17-.162-.76-.3-2.751-.606-3.487-1.107-1.02-.696-1.02-1.934 0-1.116.882-1.877.882-.76 2.735-.76 1.763 0 2.62.574.858.574 1.182 1.699l-2.144.396q-.138-.501-.526-.768-.38-.267-1.092-.267-.898 0-1.286.25-.26.179-.26.462 0 .242.227.412.308.227 2.12.64 1.82.412 2.54 1.01.712.607.712 1.692 0 1.18-.987 2.03-.987.85-2.92.85-1.756 0-2.783-.712-1.02-.712-1.335-1.934z"
        style={{ lineHeight: "1.25" }}
        fill="#fff"
        stroke="#000"
        strokeOpacity="0"
        strokeWidth="1.036"
        aria-label="Buildings"
        fontFamily="Arial"
        fontSize="16.568"
        fontWeight="bold"
        letterSpacing="0"
        transform="scale(.92896 1.07647)"
        wordSpacing="0"
      ></path>
    </svg>
  );
}

export default Icon;
